import React from 'react';

import { Modal, TabContainer } from '~components';
import { AccessSettings, AccountCodes, CompanySettings, SupplierConfig } from '~support-at-home/components/common';

interface ComponentProps {
  setIsOpen: (val: boolean) => void;
  isOpen: boolean;
}

const SupplierInvoiceSettingsModal: React.FC<ComponentProps> = ({ setIsOpen, isOpen }) => {
  const tabs = [
    { id: 'account-codes', title: 'Account Codes', component: AccountCodes },
    { id: 'access-settings', title: 'Access Settings', component: AccessSettings },
    { id: 'company-settings', title: 'Company Settings', component: CompanySettings },
    { id: 'supplier-config', title: 'Suppliers', component: SupplierConfig },
  ];
  return (
    <Modal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      size="xl"
      headerClassName="header"
      header="Invoice Settings"
      className="supplier-invoice-settings feature"
      data-cy="supplier-invoice-settings-modal"
    >
      <TabContainer tabs={tabs} />
    </Modal>
  );
};

export default SupplierInvoiceSettingsModal;
